import { Component } from "react";
import ArrowsPaging from "../ArrowsPaging";
import Card from "../Card";
import { addEventListeners, getCursorPoint, getRelativePoint, removeEventListeners } from "../../utils";

import "./style.scss";
import TitleBar from "../ui/TitleBar";

let id = 0;

class SliderCards extends Component {

    state = {
        itemsPerPage: 0,
        pages: 0,
        page: 0,
        // selectedID: null,
        cardWidth: 0,
        preDragging: false,
        dragging: false,
        x: 0,
        soft: false
    }

    constructor(props) {
        super(props)
        id++;
        this.id = id;
    }

    componentDidUpdate(prevProps){
        if(prevProps.cards!==this.props.cards) {
            // this.setState({selectedID:null});
            this.updateSize();
        }
    }

    /*componentDidUpdate() {
        let state = this.state;
        let prevItemsPerPage = state.itemsPerPage;
        let prevPages = state.pages;

        if (!this.state.itemsPerPage) {
            state.itemsPerPage = this.calculateItemsPerPage() || 0;
            state.pages = Math.ceil(this.allCards.length / state.itemsPerPage);
            if (state.page >= state.pages) state.page = state.pages - 1;            
        } else if (!this.containerHeight) this.containerHeight = this.container.clientHeight;

        if (state.itemsPerPage !== prevItemsPerPage || state.pages !== prevPages) this.setState(state);
    }*/

    componentDidMount() {
        // this.componentDidUpdate();        
        addEventListeners(this.containerRoot, "mousedown touchstart", this.mouseDownHandler);
        window.addEventListener("resize", this.updateSize);
        this.updateSize();
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateSize);
        this.containerRoot.removeEventListener("click", this.containerClickHandler);
        removeEventListeners(this.containerRoot, "mousedown touchstart", this.mouseDownHandler);
        removeEventListeners(this.containerRoot, "mousemove touchmove", this.mouseMoveHandler);
        removeEventListeners(window, "mouseup touchend", this.mouseUpHandler);
    }

    /*calculateItemsPerPage() {
        let containerRect = this.container.getBoundingClientRect();
        let nodesCount = this.container.childNodes.length;
        let firstChildRect = this.container.firstChild.getBoundingClientRect();
        let space = Math.abs(firstChildRect.width-containerRect.width);
        if(nodesCount<2 && space>10) this.container.appendChild(this.container.firstChild.cloneNode(true));
        let secondChildRect = nodesCount>1 ? this.container.childNodes[1].getBoundingClientRect() : null;
        let gap = secondChildRect ? secondChildRect.left - containerRect.left - firstChildRect.width : 0;
        if(nodesCount<2 && space>10) this.container.lastChild.remove();
        return Math.round((containerRect.width + gap) / (firstChildRect.width + gap));
    }*/

    updateSize = () => {
        /*if (this.calculateItemsPerPage()!==this.state.itemsPerPage) {
            let state = this.state;
            state.itemsPerPage = 0;
            this.setState(state);
        }*/
        let soft = window.innerWidth < 600 ? true : false;
        let fontSize = parseFloat(window.getComputedStyle(document.body, null).getPropertyValue('font-size'));
        this.gap = fontSize * 1.16666;
        // let normalWidth = fontSize*18.61111;
        let minWidth = fontSize * (window.innerWidth < 1024 ? (soft ? 8 : 15) : 16);
        let containerWidth = this.containerRoot.getBoundingClientRect().width;
        let width = null;
        let count = 0;
        if (!soft) {
            count = Math.floor((containerWidth + this.gap) / minWidth);
            let dif = (containerWidth - (count - 1) * this.gap) - (count * minWidth);
            width = (minWidth + (dif / count)) / fontSize;
        }
        let state = this.state;
        state.cardWidth = width;
        state.itemsPerPage = count;
        state.soft = soft;
        state.pages = Math.ceil(this.props.cards.length / state.itemsPerPage);
        if (state.page >= state.pages) state.page = state.pages - 1;
        this.setState(state);
    }

    pageHanler = (page) => {
        let state = this.state;
        state.page = page;
        // state.selectedID = null;
        this.setState(state);
    }

    /*onCardSelected = (id) => {
        let state = this.state;
        state.selectedID = state.selectedID === id ? null : id;
        this.setState(state);
    }*/

    mouseDownHandler = (e) => {
        if (this.state.soft) return;
        this.startCursorPoint = getCursorPoint(e, this.containerRoot);
        if ((e.button === 0 || e.button === undefined) && this.startCursorPoint.x > 0 && this.startCursorPoint.x < this.containerRoot.offsetWidth) {
            this.startPoint = getRelativePoint(this.container);
            let state = this.state;
            state.x = getRelativePoint(this.container).x;
            state.preDragging = true;
            this.setState(state);
            this.containerRoot.removeEventListener("click", this.containerClickHandler);
            addEventListeners(this.containerRoot, "mousemove touchmove", this.mouseMoveHandler);
            addEventListeners(window, "mouseup touchend", this.mouseUpHandler);
        }
    }

    containerClickHandler(e) {
        e.preventDefault();
        e.stopPropagation();
        e.currentTarget.removeEventListener("click", this.containerClickHandler);
    }

    mouseMoveHandler = (e) => {
        // e.preventDefault();
        let cursorPoint = getCursorPoint(e, this.containerRoot);
        this.deltaX = cursorPoint.x - this.startCursorPoint.x;
        let newX = this.startPoint.x + this.deltaX;
        let state = this.state;
        if (Math.abs(this.deltaX) > 3) {
            if (!state.dragging) this.containerRoot.addEventListener("click", this.containerClickHandler);
            state.dragging = true;
        }
        state.x = newX;
        this.setState(state);
    }

    mouseUpHandler = (e) => {
        let state = this.state;
        // let page = state.page;
        state.dragging = false;
        state.preDragging = false;

        let containerRootWidth = this.containerRoot.getBoundingClientRect().width;
        let result = Math.abs(state.x / (containerRootWidth + this.gap));
        let pct = result - Math.floor(result);
        if (this.deltaX > 0 && pct < .85) state.page = Math.floor(result);
        else if (this.deltaX < 0 && pct > .15) state.page = Math.ceil(result);
        state.page = Math.min(Math.max(0, state.page), state.pages - 1);
        // if (state.page !== page) state.selectedID = null;

        this.setState(state);

        removeEventListeners(this.containerRoot, "mousemove touchmove", this.mouseMoveHandler);
        removeEventListeners(window, "mouseup touchend", this.mouseUpHandler);
    }

    clickHandler = (data)=>{
        if(this.props.onCardClick) this.props.onCardClick(data);
    }

    onCardUpdate = (data) =>{
        if(this.props.onCardUpdate) this.props.onCardUpdate(data);
    }

    render() {
        /*let items = [];
        if (this.state.itemsPerPage) {
            let cards = this.allCards;
            let start = this.state.page * this.state.itemsPerPage;
            let end = Math.min(start + this.state.itemsPerPage, cards.length);

            for (let i = start; i < end; i++) {
                let card = cards[i];
                items.push(<Card key={`c-${this.id}-${i}`} id={card.id} name={card.name} price={card.price} favorite={card.favorite} imageURL={card.imageURL} selected={card.id===this.state.selectedID} onCardSelected={this.onCardSelected} />);
            }
        } else items = [<Card key={`c-${this.id}-00`} />]*/
        return (
            <>
                <section className="h-gallery">
                    <TitleBar title={this.props.title}>
                        {
                            this.state.soft ? null : <ArrowsPaging pages={this.state.pages} page={this.state.page} onPageChange={this.pageHanler} />
                        }
                    </TitleBar>
                    <div ref={el => (this.containerRoot = el)} className={`cards-scroll ${this.state.soft ? "no-scrollbar" : ""}`}>
                        {/* {items} */}
                        <div
                            ref={el => (this.container = el)}
                            className={`cards-container ${this.state.preDragging ? "dragging" : ""}`}
                            style={
                                this.state.soft ? null :
                                    {
                                        "--width": `${this.state.cardWidth ? `${this.state.cardWidth}rem` : "unset"}`,
                                        "--x": this.state.preDragging ? `${this.state.x}px` : `calc(-${100 * this.state.page}% - ${this.state.page * 1.16666}rem)`
                                    }
                            }>
                            {this.props.cards.map((data, i) => {
                                return <Card
                                    key={`c-${id}-${i}`}
                                    data={data}
                                    // selected={data.id === this.state.selectedID}
                                    soft={this.state.soft}
                                    // onCardSelected={this.onCardSelected}
                                    onCardUpdate={this.onCardUpdate}
                                    onClick={this.clickHandler}
                                />
                            })}
                        </div>
                    </div>
                </section>
            </>
        )
    }
}

export default SliderCards;